"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _core = require("@widget-editor/core");

var _shared = require("@widget-editor/shared");

var _inputGroup = _interopRequireDefault(require("../../styles-common/input-group"));

var _const = require("./const");

var _NotNullInput = _interopRequireDefault(require("./components/NotNullInput"));

var _numberFilter = _interopRequireDefault(require("./components/number-filter"));

var _dateFilter = _interopRequireDefault(require("./components/date-filter"));

var _stringFilter = _interopRequireDefault(require("./components/string-filter"));

var _style = require("./style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Filter = function Filter(_ref) {
  var setFilters = _ref.setFilters,
      patchConfiguration = _ref.patchConfiguration,
      _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? [] : _ref$filters,
      _ref$fields = _ref.fields,
      fields = _ref$fields === void 0 ? [] : _ref$fields,
      dataset = _ref.dataset;
  var columnOptions = (0, _react.useMemo)(function () {
    var usedColumns = filters.map(function (filter) {
      return filter.column;
    }).filter(function (column) {
      return !!column;
    });
    return fields.map(function (field) {
      var _constants$ALLOWED_FI, _constants$ALLOWED_FI2;

      return {
        label: field.metadata && field.metadata.alias ? field.metadata.alias : field.columnName,
        value: field.columnName,
        type: (_constants$ALLOWED_FI = (_constants$ALLOWED_FI2 = _core.constants.ALLOWED_FIELD_TYPES.find(function (type) {
          return type.name === field.type;
        })) === null || _constants$ALLOWED_FI2 === void 0 ? void 0 : _constants$ALLOWED_FI2.type) !== null && _constants$ALLOWED_FI !== void 0 ? _constants$ALLOWED_FI : 'string',
        isDisabled: usedColumns.indexOf(field.columnName) !== -1
      };
    }).sort(function (option1, option2) {
      return option1.label.localeCompare(option2.label);
    });
  }, [filters, fields]);
  var canAddFilter = (0, _react.useMemo)(function () {
    return filters.length < fields.length && filters.every(function (filter) {
      return filter.column;
    });
  }, [filters, fields]);
  var addFilter = (0, _react.useCallback)(function () {
    return setFilters({
      list: [].concat(_toConsumableArray(filters), [_objectSpread({}, _const.DEFAULT_FILTER_VALUE, {
        id: (0, _uniqueId["default"])("we-filter-")
      })])
    });
  }, [filters, setFilters]);
  var updateFilter = (0, _react.useCallback)(
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(filterId, change) {
      var patch;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Promise.all(filters.map(
              /*#__PURE__*/
              function () {
                var _ref3 = _asyncToGenerator(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee(filter) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(filter.id !== filterId)) {
                            _context.next = 2;
                            break;
                          }

                          return _context.abrupt("return", filter);

                        case 2:
                          _context.t0 = _objectSpread;
                          _context.t1 = {};
                          _context.t2 = filter;
                          _context.t3 = {};
                          _context.t4 = change;

                          if (filter.column) {
                            _context.next = 13;
                            break;
                          }

                          _context.next = 10;
                          return _core.FiltersService.fetchConfiguration(dataset, fields, change.column);

                        case 10:
                          _context.t5 = _context.sent;
                          _context.next = 14;
                          break;

                        case 13:
                          _context.t5 = filter.config;

                        case 14:
                          _context.t6 = _context.t5;
                          _context.t7 = {
                            config: _context.t6
                          };
                          return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2, _context.t3, _context.t4, _context.t7));

                        case 17:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 2:
              patch = _context2.sent;
              setFilters({
                list: patch
              });
              patchConfiguration();

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [dataset, fields, filters, patchConfiguration, setFilters]);
  var removeFilter = (0, _react.useCallback)(function (id) {
    var patch = filters.filter(function (filter) {
      return filter.id !== id;
    });
    setFilters({
      list: patch
    });
  }, [filters, setFilters]);
  return _react["default"].createElement(_style.StyledFilterBox, null, _react["default"].createElement(_style.StyledAddSection, null, _react["default"].createElement(_shared.Button, {
    size: "small",
    onClick: addFilter,
    disabled: !canAddFilter
  }, "Add filter")), !filters.length && _react["default"].createElement(_style.StyledEmpty, null, "Click \"Add filter\" to start filtering the data."), filters.map(function (filter) {
    return _react["default"].createElement(_style.StyledFilterSection, {
      key: filter.id
    }, _react["default"].createElement(_inputGroup["default"], {
      noMargins: true
    }, _react["default"].createElement(_reactSelect["default"], {
      placeholder: "Select column",
      value: columnOptions.find(function (_ref4) {
        var value = _ref4.value;
        return value === filter.column;
      }),
      options: columnOptions,
      onChange: function onChange(_ref5) {
        var value = _ref5.value,
            type = _ref5.type;
        return updateFilter(filter.id, {
          column: value,
          type: type
        });
      },
      isDisabled: !!filter.column
    }), _react["default"].createElement(_style.StyledDeleteBox, null, _react["default"].createElement(_shared.Button, {
      type: "highlight",
      onClick: function onClick() {
        return removeFilter(filter.id);
      }
    }, "Delete"))), filter.column !== null && _react["default"].createElement(_style.StyledFilter, null, filter.type === 'number' && _react["default"].createElement(_numberFilter["default"], {
      filter: filter,
      onChange: function onChange(change) {
        return updateFilter(filter.id, change);
      }
    }), filter.type === 'date' && _react["default"].createElement(_dateFilter["default"], {
      filter: filter,
      onChange: function onChange(change) {
        return updateFilter(filter.id, change);
      }
    }), filter.type === 'string' && _react["default"].createElement(_stringFilter["default"], {
      filter: filter,
      onChange: function onChange(change) {
        return updateFilter(filter.id, change);
      }
    }), _react["default"].createElement(_NotNullInput["default"], {
      filter: filter,
      onChange: function onChange(notNull) {
        return updateFilter(filter.id, {
          notNull: notNull
        });
      }
    })));
  }));
};

var _default = Filter;
exports["default"] = _default;